import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig, navLinks } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10">
      {/* Main Footer */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-5">
            <h2 className="font-serif text-4xl lg:text-5xl text-white tracking-tight">
              {siteConfig.name}
            </h2>
            <p className="font-sans text-sm text-white/50 max-w-sm mt-6 leading-relaxed">
              Cultural strategist and global thought leader, bridging heritage 
              with the future of international discourse.
            </p>
          </div>

          {/* Navigation Column */}
          <div className="lg:col-span-3">
            <h3 className="font-sans text-[11px] tracking-[0.2em] uppercase text-white/40 mb-8">
              Navigation
            </h3>
            <ul className="space-y-4">
              {navLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="font-sans text-sm text-white/70 hover:text-white transition-colors duration-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div className="lg:col-span-4">
            <h3 className="font-sans text-[11px] tracking-[0.2em] uppercase text-white/40 mb-8">
              Get in Touch
            </h3>
            <div className="space-y-4">
              <a
                href={`mailto:${siteConfig.email}`}
                className="block font-sans text-sm text-white/70 hover:text-white transition-colors duration-300"
              >
                {siteConfig.email}
              </a>
              <a
                href="mailto:mariam@alknzventures.com"
                className="block font-sans text-sm text-white/70 hover:text-white transition-colors duration-300"
              >
                mariam@alknzventures.com
              </a>
              <p className="font-sans text-sm text-white/50">
                {siteConfig.location}
              </p>
            </div>

            {/* CTA */}
            <Link
              to="/contact"
              className="inline-block mt-10 px-8 py-4 border border-white/30 text-white font-sans text-[11px] tracking-[0.2em] uppercase hover:bg-white hover:text-black transition-all duration-300"
            >
              Book a Consultation
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-sans text-xs text-white/40">
            © {currentYear} {siteConfig.name}. All rights reserved.
          </p>
          <p className="font-sans text-xs text-white/40">
            Crafted with intention
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
